// extracted by mini-css-extract-plugin
export default {"root":"Form_root__CufBO","item":"Form_item__zDOU+","erklearvideoButton":"Form_erklearvideoButton__BE3Y5"};